export const SKILL_DESCRIPTIONS = [
  {
    title: 'Communication Skills',
    text: `Communication skills allow you to understand and be understood by others. These are essential in almost every job role, helping you share ideas, give and receive information, and build professional relationships.

This skills category includes Active Listening, Speaking, Writing and Reading Comprehension.`,
  },
  {
    title: 'Problem-Solving Skills',
    text: `Problem-solving skills help you identify issues, think critically, and develop practical solutions. These are vital in roles that involve decision-making, troubleshooting, or innovation.

This skills category includes Critical Thinking, Judgement, Decision-Making and Deductive Reasoning.`,
  },
  {
    title: 'Teamwork Skills',
    text: `Teamwork skills help you work well with others to achieve common goals. Collaboration is a core part of most jobs, whether you're part of a small team or a larger organisation.

This skills category includes Persuasion, Negotiation, Empathy, Social Understanding and Coordination.`,
  },
  {
    title: 'Organisational Skills',
    text: `Organisational skills help you manage your time, tasks, and resources efficiently. These are key for meeting deadlines, staying on top of priorities, and maintaining productivity.

This skills category includes Time Management, Information Ordering and Prioritisation, Record Keeping and Resource Management.`,
  },
  {
    title: 'Creativity Skills',
    text: `Creativity skills enable you to generate new ideas, solve problems in innovative ways, and adapt to change. These are increasingly valued in dynamic and evolving workplaces.

This skills category includes Brainstorming and Ideas Generation, Originality, Storytelling and Visual Thinking.`,
  },
  {
    title: 'Learning Skills',
    text: `Learning skills support your ability to grow, adapt, and remain employable in a fast-changing job market. Being open to learning shows initiative and long-term potential.

This skills category includes: Curiosity, Self-Directed and Active Learning, Learning Strategies and Research Skills.`,
  },
  {
    title: 'Technical Skills',
    text: `Technical skills involve specific knowledge and abilities needed to perform tasks in a particular job or industry. While often learned through training or education, these can also be developed on the job.

This skills category includes: Systems Analysis and Evaluation, Troubleshooting, Maintenance and Repair, Programming, Operation and Control.`,
  },
  {
    title: 'Physical Skills',
    text: `Physical skills relate to the use of strength, coordination, stamina, or dexterity in your work. These are especially important in manual roles, construction, logistics, healthcare, and similar fields.

This skills category includes Manual Dexterity, Stamina, Strength, Flexibility.`,
  },
  {
    title: 'Manipulation Skills',
    text: `Manipulation skills are fine motor skills that involve precise hand or finger movements to control tools, instruments, or materials. These are crucial in jobs requiring detailed or delicate manual tasks.

This skills category includes Hand-Eye Coordination, Operating fine controls, Reaction Time, Spatial Orientation, Visualization and Craftsmanship.`,
  },
  {
    title: 'Leadership Skills',
    text: `Leadership skills allow you to guide, motivate, and support others to reach shared goals. You don't need to be in a management position to use leadership skills—they're valuable in any role where you take initiative or influence others.

This skills category includes Motivation, Development and Direction of people, Management and Delegation, Decision-Making, Vision-Setting and Action-Management.`,
  },
];
